import { IAssessmentResponsesPayload } from '../../../pages/Dashboard/DashboardCover/DiscoverAssess/DiscoverAssess';
import {
  ICSPAssessQuestionnaireListItem,
  IDAQuestionnaireListItem,
  IPlanCardContent,
} from '../../models/DashboardModels';
import {
  IAssessSubmitResponsePayload,
  IDAQAnswersResponsePayload,
  IDAQuestionnaireResponsePayload,
  IPlanCapabilityRequestPayload,
  IUploadAssessmentState,
} from '../../models/DevopsAnalyticsModels';
import {
  IAssessmentQuestionsResponse,
  IAssessmentResultPayload,
  IDevopsDataResponse,
  IGovAnalysisDataResponse,
  IGovDataType,
} from '../../store/state/DevOpsAnalyticsState';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.ANALYTICS;

export class DevOpsAnalyticsService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.dcaBackend);
  private readonly service2: ApiServiceBase = new ApiService(ServiceType.None, ServerType.dcaBackend);
  private readonly service3: ApiServiceBase = new ApiService(ServiceType.None, ServerType.local);

  public getCapabilityData(data: string): Promise<IDevopsDataResponse> | IDevopsDataResponse {
    const route: string[] = [API_ROUTE.ASSESSMENTS.ALTERNATE, data];
    return this.service.get({
      route: route,
    });
  }

  public getGovernanceData(
    data: string,
  ): Promise<IGovAnalysisDataResponse> | IGovAnalysisDataResponse {
    const route: string[] = [API_ROUTE.GOVERNANCE, data];
    return this.service.get({
      route: route,
    });
  }

  public getBuildDeployAssessmentData(data: {
    assessmentType: string;
    projectId: string;
  }): Promise<IGovDataType | IDevopsDataResponse> | IGovDataType | IDevopsDataResponse {
    const route: string[] = [API_ROUTE.QUESTIONNAIRE, API_ROUTE.CHART];
    return this.service2.get({
      route: route,
      query: data,
    });
  }

  public postGovernanceData(
    data: IUploadAssessmentState,
  ): Promise<IGovAnalysisDataResponse> | IGovAnalysisDataResponse {
    const route: string[] = [API_ROUTE.ASSESSMENTS.DEVOPS_UPLOAD];
    return this.service2.post(
      {
        route: route,
      },
      data,
    );
  }
  public getAssessmentQuestionsService(
    data: string,
  ): Promise<IAssessmentQuestionsResponse[]> | IAssessmentQuestionsResponse[] {
    const route: string[] = [API_ROUTE.QUESTIONNAIRE];
    return this.service2.get({
      route: route,
      query: { assessmentType: data },
    });
  }
  public setAssessmentResultService(data: IAssessmentResultPayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.QUESTIONNAIRE];
    return this.service2.post(
      {
        route: route,
      },
      data,
    );
  }
  public getAssessmentResponses(data: IAssessmentResponsesPayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.QUESTIONNAIRE, API_ROUTE.RESPONSE];
    return this.service2.get({
      route: route,
      query: { ...data },
    });
  }

  public getDisAssQuestionsList(
    data: IDAQuestionnaireResponsePayload,
  ): Promise<IDAQuestionnaireListItem[]> | IDAQuestionnaireListItem[] {
    const route: string[] = [API_ROUTE.DISCOVERY];
    return this.service2.get({
      route: route,
      query: { ...data },
    });
  }
  public saveDisAssQuestionsList(data: IDAQAnswersResponsePayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.DISCOVERY];
    return this.service2.post(
      {
        route: route,
      },
      data,
    );
  }
  public updateDisAssQuestionsList(data: IDAQAnswersResponsePayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.DISCOVERY];
    return this.service2.post(
      {
        route: route,
      },
      data,
    );
  }
  public getCspAssQuestionsList(
    data: IDAQuestionnaireResponsePayload,
  ): Promise<ICSPAssessQuestionnaireListItem[]> | ICSPAssessQuestionnaireListItem[] {
    const route: string[] = [API_ROUTE.DISCOVERY];
    return this.service2.get({
      route: route,
      query: { ...data },
    });
  }
  public saveCspAssQuestionsList(data: IAssessSubmitResponsePayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.DISCOVERY];
    return this.service2.post(
      {
        route: route,
      },
      data,
    );
  }

  public getPlanCapabilityList(data: string): Promise<IPlanCardContent[]> | IPlanCardContent[] {
    const route: string[] = [API_ROUTE.PLAN_CAPABILITY_DETAILS];
    return this.service2.get({
      route: route,
      query: {projectId: data},
    });
  }

  public savePlanCapabilityList(data: IPlanCapabilityRequestPayload): Promise<string> | string {
    const route: string[] = [API_ROUTE.PLAN_CAPABILITY_DETAILS];
    return this.service2.post(
      {
        route: route,
        query: {projectId: data.projectId},
      },
      data.capabilityListData,
    );
  }
}

const devOpsAnalyticsService = new DevOpsAnalyticsService();
export default devOpsAnalyticsService;
